import React from 'react';
import PropTypes from 'prop-types';

import { format, parseISO } from 'date-fns';
import Grid from '@material-ui/core/Grid';
import InputLabel from '~/components/InputLabel';

import { Container, BoxValue } from './styles';

function PatientData({ patient }) {
  const dateParsed = patient
    ? format(parseISO(patient.created_at), 'dd/MM/yyyy')
    : '00/00/0000';
  const hourParsed = patient
    ? format(parseISO(patient.created_at), 'HH:mm:ss')
    : '00:00:00';

  return (
    <Container>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <InputLabel>Registro</InputLabel>
          <BoxValue>{patient ? patient.register : '0000-00/0000'}</BoxValue>
        </Grid>

        <Grid item xs={4}>
          <InputLabel>Data</InputLabel>
          <BoxValue>{dateParsed}</BoxValue>
        </Grid>

        <Grid item xs={4}>
          <InputLabel>Hora</InputLabel>
          <BoxValue>{hourParsed}</BoxValue>
        </Grid>
      </Grid>
    </Container>
  );
}

PatientData.propTypes = {
  patient: PropTypes.shape({
    register: PropTypes.number,
    created_at: PropTypes.string,
  }),
};

PatientData.defaultProps = {
  patient: {},
};

export default PatientData;
